import React from "react";
import Hero from "./sections/hero";
import FeaturesSection from "./sections/features";
import AboutSection from "./sections/about";
import ServicesSection from "./sections/our_services";
import CTASection from "./sections/CTA";
import ContactSection from "./sections/contact";
import ClienteleSection from "./sections/clientele";
import Navbar from "../../components/navbar";
import Destinations from "./sections/destinations";
import Testimonials from "./sections/testimonials";
import PartnerSchools from "./sections/partner_schools";
import FAQs from "./sections/faq";

const Landing = () => {
  return (
    <div>
      <div>
        <Hero />
      </div>
      <div id="about" className="py-20 bg-gray-200">
        <AboutSection />
      </div>
      <div
        id="services"
        className="py-20 bg-gradient-to-b from-gray-50 to-white"
      >
        <ServicesSection />
      </div>
      <div id="schools" className="py-20 bg-gray-200">
        <PartnerSchools />
      </div>
      <div className="py-20" id="destinations">
        <Destinations />
      </div>

      <div id="features">
        <FeaturesSection />
      </div>

      {/* <div className="bg-cyan-500 py-20" id="cta">
        <CTASection />
      </div> */}
      <div
        className="relative py-10"
        id="testimonials"
        style={{
          backgroundImage: "url(/testimonial-bg.jpg)",
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 z-10"></div>
        <Testimonials />
      </div>
      <div className="py-20" id="contact-us">
        <ContactSection />
      </div>
      <div className="pb-20" id="faqs">
        <FAQs />
      </div>
    </div>
  );
};

export default Landing;
